import React from 'react'
import {BottomMenu} from '@therms/atalaya'
import {LocationsMobileMenuLink} from '@src/modules/Locations/shared/Layout/MobileMenuLink'
import {StatsMobileMenuLink} from '../../Stats/shared/Layout/MobileMenuLink'

function MobileNav() {
  return (
    <BottomMenu background="surface">
      <nav className="flex">
        <LocationsMobileMenuLink />

        <StatsMobileMenuLink />
      </nav>
    </BottomMenu>
  )
}

export {MobileNav}
